<script setup lang="ts">
import Roboto from '@/atoms/global/texts/Roboto.vue'
import { useTeamStore } from '@/store/teamStore'
const teamStore = useTeamStore()
const { currentTeam } = storeToRefs(teamStore)
</script>

<template>
  <div class="lo-v-end">
    <section class="price-table bg-sub-16 pd-page">
      <div class="lo-h-center fill-wt">
        <label class="gray-1">1ユーザーあたり(税込)</label>
        <spacer />
        <div class="lo-h-center">
          <Roboto class="size-20px bold">
            {{ currentTeam?.plan.pricePerUser }}
          </Roboto>
          <sup-label class="gray-1 mg-left-4px"> 円/月 </sup-label>
        </div>
      </div>
      <hr />
      <div class="lo-h-center fill-wt">
        <label class="gray-1">メンバー数</label>
        <spacer />
        <div class="lo-h-center">
          <Roboto class="size-20px bold">
            {{ currentTeam?.approvedMembers.length }}
          </Roboto>
          <sup-label class="gray-1 mg-left-4px"> 人 </sup-label>
        </div>
      </div>
      <hr />
      <div class="lo-h-center fill-wt">
        <label class="gray-1">合計金額(税込)※</label>
        <spacer />
        <div class="lo-h-center">
          <Roboto class="size-24px bold">
            {{ currentTeam?.price }}
          </Roboto>
          <sup-label class="gray-1 mg-left-4px"> 円/月 </sup-label>
        </div>
      </div>
    </section>
    <div class="lo-v-start">
      <sup-description class="mg-top-4px">
        ※支払いを行なったユーザーがチームの支払い管理者になります。
      </sup-description>
      <sup-description class="mg-top-4px">
        ※メンバーの増減に応じて、料金は変動します。
        <a
          href="https://help.nitte.app/about_trial#block-ce77db2ac4c7439a9901920e928b9306"
          target="_blank"
          >詳しく見る</a
        >
      </sup-description>
    </div>
  </div>
</template>

<style scoped>
.price-table {
  width: 417px;
}
@media screen and (max-width: 800px) {
  .price-table {
    width: 100%;
  }
}
hr {
  margin: var(--base-12px) 0;
}
</style>
